import { render, staticRenderFns } from "./MeasurementIcon.vue?vue&type=template&id=f5233774&scoped=true"
import script from "./MeasurementIcon.vue?vue&type=script&lang=js"
export * from "./MeasurementIcon.vue?vue&type=script&lang=js"
import style0 from "./MeasurementIcon.vue?vue&type=style&index=0&id=f5233774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5233774",
  null
  
)

export default component.exports